import schema from './runtime-config.schema.json';
import { validateRuntimeConfig } from './runtime-config.validation';

type RuntimeConfig = {
  schemaVersion: number;
  environment: 'local' | 'staging' | 'production';
  allowedHosts: string[];
  values: Record<string, string | undefined>;
};
let loaded: RuntimeConfig | undefined;

export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch('/runtime-config.json', {
    cache: 'no-store',
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error('Runtime configuration unavailable');
  loaded = validateRuntimeConfig(await response.json(), schema, window.location.hostname);
  Object.freeze(loaded!.values);
  Object.freeze(loaded);
}

export function getRuntimeValues(): Record<string, string | undefined> {
  if (!loaded) throw new Error('Runtime configuration has not loaded');
  return loaded.values;
}
